import React from "react"
import {MenuItem} from "react-bootstrap"
import {InjectIntl, injectIntl} from "@irati/utils/lang"
import {GroupCelebration, GroupCelebrationStatus} from "@irati/types"
import MenuActions, {MenuActionsProps} from "../../shared/MenuActions"

export enum ScheduledGroupCelebrationActionsTypes {
  DELETE,
  EDIT_DATE
}
const ActionsList = [
  {
    key: ScheduledGroupCelebrationActionsTypes.DELETE,
    label: "platform.recognition.popup.groupCelebration.actions.delete"
  },
  {
    key: ScheduledGroupCelebrationActionsTypes.EDIT_DATE,
    label: "platform.recognition.popup.groupCelebration.actions.editDate",
    canShow: (groupCelebration: GroupCelebration) => groupCelebration.status === GroupCelebrationStatus.Scheduled
  }
]
interface Props extends Partial<MenuActionsProps>, InjectIntl {
  groupCelebration: GroupCelebration
  onActionClick: (action: ScheduledGroupCelebrationActionsTypes) => void
}

const ScheduledGroupCelebrationActions: React.FC<Props> = (props) => {
  const {groupCelebration, onActionClick, formatMessage, ...otherProps} = props
  return (
    <MenuActions item={groupCelebration} {...otherProps}>
      {() =>
        ActionsList.filter(({canShow}) => !canShow || canShow(groupCelebration)).map((action) => (
          <MenuItem key={action.key} onSelect={() => onActionClick(action.key)}>
            {formatMessage({id: action.label})}
          </MenuItem>
        ))
      }
    </MenuActions>
  )
}
export default injectIntl(ScheduledGroupCelebrationActions)
